import { gql } from "@apollo/client";
import FormText from "controls/FormText";
import MultiValuesField from "controls/MultiValuesField";
import useData from "hooks/useData";
import DateTimeInput from "inputs/DateTimeInput";
import DurationInput from "inputs/DurationInput";
import SwitchInput from "inputs/SwitchInput";
import React from "react";
import ReadminObjectInput from "readmin_pages/shared/ReadminObjectInput";

export const PracticeGameSchedulesFormFragment = gql`
  fragment PracticeGameSchedulesFormFragment on GameSchedule {
    practice
    court {
      id
    }
    org {
      id
    }
    scheduledAt
    durationSeconds
    cancelled
  }
`;

export function PracticeGameSchedulesForm({ orgId, courtId, gameSchedules }) {
  const resolvedOrgId = orgId || gameSchedules?.[0]?.org?.id;

  const [data] = useData(
    gql`
      query PracticeGameSchedulesFormOrg($orgId: ID!) {
        org(id: $orgId) {
          id
          defaultGameDurationSeconds
        }
      }
    `,
    { orgId: resolvedOrgId },
    { skip: !resolvedOrgId },
  );

  const orgDefaultDuration = data?.org?.defaultGameDurationSeconds || 600;

  const defaultCourt = gameSchedules
    ? gameSchedules.map((g) => g.court)
    : courtId
      ? [{ id: courtId, __typename: "Court" }]
      : undefined;

  const defaultScheduledAt = gameSchedules?.map((g) => g.scheduledAt);
  const defaultDuration = gameSchedules?.map((g) => g.durationSeconds) || [orgDefaultDuration];
  const defaultCancelled = gameSchedules?.map((g) => g.cancelled ?? false);

  return (
    <>
      <FormText uiStringKey="readmin.practice_schedule.description" />

      <MultiValuesField
        label="Court"
        name="court"
        defaultValues={defaultCourt}
        helperTextUiStringKey="readmin.game_schedule.fields.court"
        input={<ReadminObjectInput optionsTypename="Court" />}
        required
      />

      <MultiValuesField
        label="Scheduled At"
        name="scheduledAt"
        defaultValues={defaultScheduledAt}
        helperTextUiStringKey="readmin.game_schedule.fields.scheduled_at"
        input={<DateTimeInput />}
        required
      />

      <MultiValuesField
        label="Duration"
        name="durationSeconds"
        defaultValues={defaultDuration}
        helperTextUiStringKey="readmin.game_schedule.fields.duration"
        input={<DurationInput unit="seconds" max={10800} />}
        required
      />

      {gameSchedules && (
        <MultiValuesField
          label="Cancelled"
          name="cancelled"
          helperTextUiStringKey="readmin.game_schedule.fields.cancelled"
          defaultValues={defaultCancelled}
          input={<SwitchInput />}
        />
      )}
    </>
  );
}
